import { useTrackingEventsDatas } from "./useTracking";
import { useTrackingEvent } from "./useTrackingEvent";
export const useTrackingLeadForm = ({ event, av_zone, }) => {
    const EVENT_DATA = {
        ...useTrackingEventsDatas({
            displayMedium: true,
            conversionType: "mail",
            av_zone,
        }),
        event,
    };
    return useTrackingEvent(EVENT_DATA);
};
